@if (scoreCourant?.ruleset) {
  <h4 class="ruleset defaut">{{ 'attestations-score-rule-set' | translate }} <b>{{scoreCourant?.ruleset}}</b></h4>
}
@if (typeScorePrevention() == 'default') {
  <div class="d-flex flex-column defgrey">
    <div class="d-flex flex-row head justify-content-between">
      <div class="gscore d-flex flex-row">
        <h4 class="defaut">{{ 'attestations-score-global' | translate }}:</h4>
        <div class="card border-0">
          <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
            <div class="card border-0">
              <mat-progress-spinner [color]="'primary'" [mode]="'determinate'"
                [value]="formatScore(scoreCourant?.scorePrevention)" class="card-img">
              </mat-progress-spinner>
              <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
                <h3 class="letter-spacing text-muted text-center">
                  {{ formatScore(scoreCourant?.scorePrevention) }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="totalRules d-flex flex-row justify-content-end">
        <h4 class="defaut">{{ 'attestation-preventional-score-rules-check' | translate }}:</h4>
        <h4 class='id'>{{scoreCourant?.totalRulechecks}}</h4>
      </div>
    </div>
    <div class="liste d-flex flex-wrap justify-content-center">
      @for (k of getSubScoreBreak(); track k) {
        <div class="d-flex flex-column justify-content-center">
          @if (formatScoreFamily(k[0]) != 'black&White') {
            <img id="probe-{{k[0].toLowerCase()}}" class="{{statutScorePrevention(k[1])}} align-self-center"
              src="assets/icons/probesFamilies/{{formatScoreFamily(k[0].toLowerCase())}}.svg">
          }
          @if (formatScoreFamily(k[0]) == 'black&White') {
            <img id="probe-{{k[0].toLowerCase()}}" class="{{statutScorePrevention(k[1])}} align-self-center"
              src="assets/icons/probesFamilies/{{formatScoreFamily(k[0])}}.png">
          }
          <h5 class="text-capitalize">{{formatScoreFamily(k[0])}}: <b>{{k[1]}}</b></h5>
        </div>
      }
    </div>
  </div>
} @else {
  @if (typeScorePrevention() == 'greylist') {
    <div class="d-flex flex-column defgrey">
      <h4>{{ 'attestation-preventional-score-greylisted' | translate }}</h4>
      <div class="d-flex flex-row head justify-content-between">
        <div class="gscore d-flex flex-row">
          <h4 class="defaut">{{ 'attestations-score-global' | translate }}:</h4>
          <div class="card border-0">
            <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
              <div class="card border-0">
                <mat-progress-spinner [color]="'primary'" [mode]="'determinate'"
                  [value]="formatScore(scoreCourant?.scorePrevention)" class="card-img">
                </mat-progress-spinner>
                <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
                  <h3 class="letter-spacing text-muted text-center">
                    {{ formatScore(scoreCourant?.scorePrevention) }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalRules d-flex flex-row justify-content-end">
          <h4 class="defaut">{{ 'attestation-preventional-score-rules-check' | translate }}:</h4>
          <h4 class='id'>{{scoreCourant?.totalRulechecks}}</h4>
        </div>
      </div>
      <div class="liste d-flex flex-wrap justify-content-center">
        @for (gr of getGreylist(); track gr) {
          <div class="d-flex flex-column justify-content-center">
            <img class="align-self-center" src="assets/icons/greylist.svg">
            <h5 class="text-capitalize">{{gr.name}}</h5>
            <h6>{{ 'attestation-preventional-score-impact-weigth' | translate }}: {{gr.weight}}</h6>
          </div>
        }
        @for (k of getSubScoreBreak(); track k) {
          <div class="d-flex flex-column justify-content-center">
            @if (formatScoreFamily(k[0]) != 'black&White') {
              <img id="probe-{{k[0].toLowerCase()}}" class="{{statutScorePrevention(k[1])}} align-self-center"
                src="assets/icons/probesFamilies/{{formatScoreFamily(k[0].toLowerCase())}}.svg">
            }
            @if (formatScoreFamily(k[0]) == 'black&White') {
              <img id="probe-{{k[0].toLowerCase()}}" class="{{statutScorePrevention(k[1])}} align-self-center"
                src="assets/icons/probesFamilies/{{formatScoreFamily(k[0])}}.png">
            }
            <h5 class="text-capitalize">{{formatScoreFamily(k[0])}}: <b>{{k[1]}}</b></h5>
          </div>
        }
      </div>
    </div>
  } @else {
    @if (typeScorePrevention() == 'whitelist') {
      <div class="d-flex flex-column">
        <hr class="whitelist d-flex align-self-center">
        <h4 class="text-center">{{ 'attestation-preventional-score-whitelisted' | translate }}</h4>
        <hr class="whitelist d-flex align-self-center">
      </div>
    } @else {
      @if (typeScorePrevention() == 'blacklist') {
        <div class="d-flex flex-column">
          <hr class="blacklist d-flex align-self-center">
          <h4 class="text-center">{{ 'attestation-preventional-score-blacklisted' | translate }}</h4>
          <hr class="blacklist d-flex align-self-center">
        </div>
      }
    }
  }
}


